module.exports = __webpack_public_path__ + "static/img/fullscreen.7340c95f.svg";